import * as React from 'react';

import * as RadixLabel from '@radix-ui/react-label';
import clsx from 'clsx';

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof RadixLabel.Root> {
  className?: string;
  required?: boolean;
}

/**
 * Label component is a design system adapter for Radix Label.
 * It supports all standard props and can be used with any form field.
 */
export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <RadixLabel.Root ref={ref} className={clsx('label', className)} {...props}>
      {children}
      {required && <span className="label__required">*</span>}
    </RadixLabel.Root>
  )
);

Label.displayName = 'Label';
